import { AxiosError, AxiosResponse } from 'axios';
import { UseMutationOptions } from 'react-query';

import useAPIMutation from '../api/useAPIMutation';
import { JobPostingCollection, JobPostingDetail } from '../types';

interface CreateJobPostingInput {
  name: string;
  positions: number;
  startSalaryRange?: number;
  endSalaryRange?: number;
  limitDays?: number;
  seniorityLevel?: number;
  workModel?: JobPostingDetail['work_model'];
  hireModel?: JobPostingDetail['hire_model'];
}

const useCreateJobPostingMutation = (
  options?: Omit<
    UseMutationOptions<
      AxiosResponse<JobPostingCollection, unknown>,
      AxiosError<unknown, unknown>,
      CreateJobPostingInput,
      unknown
    >,
    'mutationFn'
  >
) => {
  return useAPIMutation(async (variables: CreateJobPostingInput, api) => {
    return await api.post('/job-postings/', {
      name: variables.name,
      positions: variables.positions,
      status: 'IN_PROGRESS',
      start_salary_range: variables.startSalaryRange,
      end_salary_range: variables.endSalaryRange,
      limit_days: variables.limitDays,
      seniority_level: variables.seniorityLevel || null,
      work_model: variables.workModel,
      hire_model: variables.hireModel,
    });
  }, options);
};

export default useCreateJobPostingMutation;
